// extracted by mini-css-extract-plugin
module.exports = {"adGoogleScore":"AdGoogleScore_adGoogleScore__xFb0T","title":"AdGoogleScore_title__1pJwy","icon":"AdGoogleScore_icon__2zaPt"};